import { ElementRef, Injectable, RendererFactory2 } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
declare const hbspt: {
    forms: {
        create: ({ region, portalId, formId }) => {
            id: string;
            instanceId: string;
        };
    };
};
@Injectable({
    providedIn: 'root'
})
export class HubspotContactFormService {
    script?: HTMLScriptElement;
    private renderer2 = this.rendererFactory2.createRenderer(null, null);
    private loaded = false;
    constructor(
        private timeoutService: TimeoutService,
        private rendererFactory2: RendererFactory2
    ) {}
    load = this.timeoutService.debounce((options: { elementRef: ElementRef; portalId: string; formId: string }) => {
        if (!this.loaded) {
            this.loaded = true;
            const script = this.renderer2.createElement('script') as HTMLScriptElement;
            script.type = 'text/javascript';
            script.onload = () => {
                this.createForm(options.elementRef, options.portalId, options.formId);
            };
            script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
            this.renderer2.appendChild(document.head, script);
        } else {
            this.createForm(options.elementRef, options.portalId, options.formId);
        }
    }, 200);
    private createForm(elementRef: ElementRef, portalId: string, formId: string): void {
        const formData = hbspt.forms.create({
            region: 'eu1',
            portalId: portalId,
            formId: formId
        });
        const form = document.getElementById(`hbspt-form-${formData.instanceId}`);
        this.renderer2.appendChild(elementRef.nativeElement, form);
    }
}
